import { render, staticRenderFns } from "./Minions.vue?vue&type=template&id=7bfde693&scoped=true&"
import script from "./Minions.vue?vue&type=script&lang=js&"
export * from "./Minions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfde693",
  null
  
)

export default component.exports